import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import productBadgeMessages from 'i18n/productBadgeMessages'
import { anywhereLabelMessage } from 'hooks/useAnywherePlace'

function useSearchLabels() {
  const intl = useIntl()

  return useMemo(() => {
    const anywhereLabel = intl.formatMessage(anywhereLabelMessage)

    const customerRatingToLabel: Record<string, string> = {
      7: intl.formatMessage({
        id: 'bo3I7OZsbnIxdgfFINtm',
        defaultMessage: 'Good',
      }),
      8: intl.formatMessage({
        id: 'g904KS_2uinGKwZLpmjL',
        defaultMessage: 'Very Good',
      }),
      9: intl.formatMessage({
        id: 'xQb__X2QpFfKBYX2wH0q',
        defaultMessage: 'Exceptional',
      }),
    }

    const limitedTimeLuxExclusive = intl.formatMessage(
      productBadgeMessages.limitedTimeLuxExclusiveLe,
    )

    const allLuxPlusRecentFilter = intl.formatMessage({
      id: 'u5dDCLygd29MyJuZKSbK',
      defaultMessage: 'All LuxPlus+ offers',
    })

    return {
      anywhereLabel,
      customerRatingToLabel,
      limitedTimeLuxExclusive,
      allLuxPlusRecentFilter,
    }
  }, [intl])
}

export default useSearchLabels
